import apiAxios, { SYNC_TIMEOUT } from '@/services/axios/axiosConfig';

async function subscribe(jsonData: object) {
  return apiAxios.post<void>(
    '/api/subscribe',
    jsonData,
    {
      timeout: SYNC_TIMEOUT,
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
}

export default subscribe;
